export default __webpack_public_path__ + "static/media/Tech-Augmented-Workforce.885eb3c5.svg";